import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {FetchCompanyVotesByDatePayload} from '../../actions/companyCommand';
import Event from '../../actions/event';
import Api from '../../../api';
import {CompanyVotesByDate} from '../../types/Company';
import {isValidDateRange, isValidISODate} from '../../../util/validateDate';

const onFetchCompanyVotesByDate = function*(data: FetchCompanyVotesByDatePayload) {
    try {
        // Validate date formats
        if (!isValidISODate(data.startDate) || !isValidISODate(data.endDate)) {
            yield put(Command.Notification.enqueueNotification({
                severity: 'error',
                message: 'Ungültiges Datumsformat. Bitte YYYY-MM-DD verwenden.',
            }));
            yield put(Event.Company.companyVotesByDateFetched({ companyVotesMap: {} }));
            return;
        }

        // Validate date range
        if (!isValidDateRange(data.startDate, data.endDate)) {
            yield put(Command.Notification.enqueueNotification({
                severity: 'error',
                message: 'Das Startdatum muss vor oder gleich dem Enddatum sein.',
            }));
            yield put(Event.Company.companyVotesByDateFetched({ companyVotesMap: {} }));
            return;
        }

        const companyVotesMap: Record<string, CompanyVotesByDate> = yield call(
            Api.Query.companyVotesByDate,
            data.startDate,
            data.endDate,
            data.version,
        );

        yield put(Event.Company.companyVotesByDateFetched({ companyVotesMap }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Die Abstimmungsstatistiken konnten nicht geladen werden.',
        }));
        yield put(Event.Company.companyVotesByDateFetched({ companyVotesMap: {} }));
    }
};

export function* fetchCompanyVotesByDateFlow() {
    while (true) {
        const action: Action<FetchCompanyVotesByDatePayload> = yield take(
            Command.Company.fetchCompanyVotesByDate.toString(),
        );

        yield fork(onFetchCompanyVotesByDate, action.payload);
    }
}
